var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectronicsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.43604C15.2766 6.43604 15.6649 6.43604 15.9711 6.5629C16.3795 6.73206 16.704 7.05652 16.8731 7.4649C17 7.77118 17 8.15947 17 8.93604C17 9.7126 17 10.1009 16.8731 10.4072C16.704 10.8156 16.3795 11.14 15.9711 11.3092C15.6649 11.436 15.2766 11.436 14.5 11.436L9.5 11.436C8.72343 11.436 8.33515 11.436 8.02886 11.3092C7.62048 11.14 7.29602 10.8156 7.12687 10.4072C7 10.1009 7 9.7126 7 8.93603C7 8.15947 7 7.77118 7.12687 7.4649C7.29602 7.05652 7.62048 6.73206 8.02886 6.5629C8.33515 6.43604 8.72343 6.43604 9.5 6.43604L14.5 6.43604Z",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.436H9M9 17.436L7 17.436M9 17.436L9 19.436M9 17.436L9 15.436",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.436V16.436",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.436V11.436C21 7.6863 21 5.81144 20.0451 4.49711C19.7367 4.07264 19.3634 3.69935 18.9389 3.39095C17.6246 2.43604 15.7497 2.43604 12 2.43604C8.25027 2.43604 6.3754 2.43604 5.06107 3.39095C4.6366 3.69935 4.26331 4.07264 3.95491 4.49711C3 5.81144 3 7.6863 3 11.436L3 13.436C3 17.1858 3 19.0606 3.95491 20.375C4.26331 20.7994 4.6366 21.1727 5.06107 21.4811C6.3754 22.436 8.25027 22.436 12 22.436C15.7497 22.436 17.6246 22.436 18.9389 21.4811C19.3634 21.1727 19.7367 20.7994 20.0451 20.375C21 19.0606 21 17.1858 21 13.436Z",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronicsIcon);
export default __webpack_public_path__ + "static/media/electronics-icon.6daa374f074db01344e396a39d7f8dd3.svg";
export { ForwardRef as ReactComponent };